module.exports = __webpack_public_path__ + "img/3.82008656.png";